/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import SearchItemHome from './SearchItem/SearchItemHome';
import { createStyles, makeStyles } from '@material-ui/styles';
import { IAnnounce } from '../../../utils/AnnounceInterfaces';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        // Your styles here
    },
    // Other styles
}));

interface SearchResultHomeProps {
    announces: IAnnounce[];
    user?: any;
    loadingItem: string[];
    onAddToFavorite: (id: string) => void;
    onRemoveToFavorite: (id: string) => void;
    changingFav: boolean; // Add this line
    searchTypeName: "cars" | "apts" | "htls" | "trs" | "evts" | "rstt";
    usage: string;
    commissionFee?: number;
}

const SearchResultHome: React.FC<SearchResultHomeProps> = ({
    announces,
    user,
    loadingItem,
    onAddToFavorite,
    onRemoveToFavorite,
    changingFav,
    searchTypeName,
    usage,
    commissionFee
}) => {
    const classes = useStyles();

    const handleAddToFav = (itemId: string) => {
        onAddToFavorite(itemId);
    };

    const handleRemToFav = (itemId: string) => {
        onRemoveToFavorite(itemId);
    };

    const limitedAnnounces = announces.slice(0, 12);

    return (
        <Grid container spacing={3} className={classes.gridContainer}>
            {limitedAnnounces.map((announce) => (
                <Grid item lg={4} md={4} sm={6} xs={12} key={announce._id}>
                    <SearchItemHome
                        data={announce}
                        user={user}
                        isFav={Boolean(user?.favorites?.includes(announce._id))}
                        changingFav={loadingItem.includes(announce._id!)}
                        onAddToFavorite={() => handleAddToFav(announce._id!)}
                        onRemoveToFavorite={() => handleRemToFav(announce._id!)}
                        searchTypeName={searchTypeName}
                        usage={usage}
                        commissionFee={commissionFee}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default SearchResultHome;
